import InstructorAccountItemRadioButton from './accountRadioButton';

import './styles.css';

export default function DecisionTypeSelector({
  gameType,
  scenarioLevelNumber,
  decisionTypes,
  editingScenarioLevelDecisionType,
  selectedDecisionType,
  onDecisionTypeSelect
}) {
  const getDisabledState = (key) => {
    if (gameType === 'Account Classification') {
      const enabledKeys = {
        1: ['class-elements', 'classified-multistep'],
        2: ['class-default', 'class-tricky', 'classified-multistep'],
        3: ['class-tricky', 'classified-multistep']
      };

      return !enabledKeys[scenarioLevelNumber]?.includes(key);
    }
    
    if (gameType === 'Normal Balance') {
      const enabledKeys = {
        1: ['norm-elements'],
        2: ['norm-default', 'norm-tricky'],
        3: ['norm-tricky']
      };
      
      return !enabledKeys[scenarioLevelNumber]?.includes(key);
    }
    
    if (gameType === 'Balanced Equation') {
      const enabledKeys = {
        1: ['increase-decrease'],
        2: editingScenarioLevelDecisionType === 'income-statement-impact' ? ['income-statement-impact'] : ['debit-credit', 'accounts-impacted', 'income-statement-impact'],
        3: editingScenarioLevelDecisionType === 'income-statement-impact' ? ['income-statement-impact'] : ['accounts-impacted', 'income-statement-impact', 'all-types']
      };
      
      return !enabledKeys[scenarioLevelNumber]?.includes(key);
    }
    
    if (gameType === 'The Principles') {
      // Only two decision types are user-selectable now — keep both
      // enabled at every level. Removed the per-level revenue-only /
      // expense-only / revenue-expense splits since those internal
      // ids are no longer surfaced in the picker.
      const enabledKeys = ['assumptions-principles-constraints', 'revenue-expense'];
      return !enabledKeys.includes(key);
    }
    
    return false;
  };

  return (
    <div className="decision-type-container">
      <h5>Decision Type</h5>
      {Object.entries(decisionTypes || {}).map(([key, label]) => {
        const disabled = getDisabledState(key);
        
        return (
          <InstructorAccountItemRadioButton
            key={key}
            id={`decision-type-${key}`}
            isChecked={selectedDecisionType === key}
            label={label}
            onCheck={() => !disabled && onDecisionTypeSelect(key)}
            disabled={disabled}
            title={disabled ? "This option isn't available for this level" : ''}
          />
        );
      })}
    </div>
  );
}